export default function tabsWidget(editor) {
  editor.DomComponents.addType('eb-tabs', {
    isComponent(el) {
      return el.getAttribute && el.getAttribute('data-gjs-type') === 'eb-tabs'
    },
    model: {
      defaults: {
        name: 'Tabs',
        tagName: 'div',
        droppable: false,
        attributes: { 'data-gjs-type': 'eb-tabs' },
        style: { 'padding': '10px' },
        components: `
          <style>
            .eb-tabs-wrap input[type="radio"] { display: none; }
            .eb-tabs-wrap .eb-tab-labels { display: flex; border-bottom: 2px solid #e0e0e0; margin-bottom: 0; }
            .eb-tabs-wrap .eb-tab-label { padding: 12px 24px; cursor: pointer; font-size: 14px; font-weight: 600; color: #666; border-bottom: 2px solid transparent; margin-bottom: -2px; transition: color 0.2s, border-color 0.2s; }
            .eb-tabs-wrap .eb-tab-label:hover { color: #667eea; }
            .eb-tabs-wrap .eb-tab-panel { display: none; padding: 20px 0; }
            .eb-tabs-wrap #eb-tab-r1:checked ~ .eb-tab-labels .eb-tab-label[for="eb-tab-r1"],
            .eb-tabs-wrap #eb-tab-r2:checked ~ .eb-tab-labels .eb-tab-label[for="eb-tab-r2"],
            .eb-tabs-wrap #eb-tab-r3:checked ~ .eb-tab-labels .eb-tab-label[for="eb-tab-r3"] { color: #667eea; border-bottom-color: #667eea; }
            .eb-tabs-wrap #eb-tab-r1:checked ~ .eb-tab-panels .eb-tab-panel:nth-child(1),
            .eb-tabs-wrap #eb-tab-r2:checked ~ .eb-tab-panels .eb-tab-panel:nth-child(2),
            .eb-tabs-wrap #eb-tab-r3:checked ~ .eb-tab-panels .eb-tab-panel:nth-child(3) { display: block; }
          </style>
          <div class="eb-tabs-wrap">
            <input type="radio" name="eb-tabs" id="eb-tab-r1" checked />
            <input type="radio" name="eb-tabs" id="eb-tab-r2" />
            <input type="radio" name="eb-tabs" id="eb-tab-r3" />
            <div class="eb-tab-labels">
              <label class="eb-tab-label" for="eb-tab-r1">Tab 1</label>
              <label class="eb-tab-label" for="eb-tab-r2">Tab 2</label>
              <label class="eb-tab-label" for="eb-tab-r3">Tab 3</label>
            </div>
            <div class="eb-tab-panels">
              <div class="eb-tab-panel"><p style="color:#555;line-height:1.6;">Content for Tab 1. Click to edit this text.</p></div>
              <div class="eb-tab-panel"><p style="color:#555;line-height:1.6;">Content for Tab 2. Click to edit this text.</p></div>
              <div class="eb-tab-panel"><p style="color:#555;line-height:1.6;">Content for Tab 3. Click to edit this text.</p></div>
            </div>
          </div>
        `,
        traits: [
          { type: 'number', name: 'data-tab-count', label: 'Number of Tabs (1-5)', min: 1, max: 5, default: 3 },
        ],
      },
    },
  })

  editor.BlockManager.add('eb-tabs', {
    label: 'Tabs',
    category: 'General',
    media: '<svg viewBox="0 0 24 24"><path fill="currentColor" d="M21,3H3A2,2 0 0,0 1,5V19A2,2 0 0,0 3,21H21A2,2 0 0,0 23,19V5A2,2 0 0,0 21,3M21,19H3V7H21V19M3,5V5H9V5H3Z"/></svg>',
    content: { type: 'eb-tabs' },
  })
}
